import {useRef} from 'react';

import {useDiscardChangesLabels} from './DiscardChangesProvider';
import {cn} from '../../lib/utils';
import {modalSizeVariants} from '../Modal/modal.config';
import {Button} from '../shadcn/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../shadcn/dialog';

import type {FC} from 'react';

export interface DiscardChangesModalProps {
  isOpen: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
  description?: string;
}

// Built on the Dialog primitives rather than Modal, because Modal renders this component.
export const DiscardChangesModal: FC<DiscardChangesModalProps> = ({
  isOpen,
  onKeepEditing,
  onDiscard,
  description
}) => {
  const labels = useDiscardChangesLabels();
  const keepEditingRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => {
        if (!open) onKeepEditing();
      }}
    >
      <DialogContent
        showCloseButton={false}
        className={cn('gap-6', modalSizeVariants({size: 'sm'}))}
        initialFocus={keepEditingRef}
      >
        <DialogHeader className="items-start gap-2">
          <DialogTitle className="text-lg">{labels.title}</DialogTitle>
          <DialogDescription className="text-start">
            {description ?? labels.description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2">
          <Button ref={keepEditingRef} variant="primary" size="stretch" onClick={onKeepEditing}>
            {labels.keepEditingLabel}
          </Button>
          <Button variant="tertiary" destructive size="stretch" onClick={onDiscard}>
            {labels.discardLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
